import { useDataLayerAction } from '@components/OOKA/pylot-tag-manager/src/TagContext'
import { useEffect } from 'react'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'

export const usePdpTracking = (
    product?: Maybe<ProductInterface>,
    upSellCrossSell?: any
): void => {
    const dataLayerAction = useDataLayerAction()
    const isClient = typeof window !== 'undefined'
    const isPromotionalProductTileClicked =
        isClient && localStorage.getItem('promotionBanner') !== null

    useEffect(() => {
        if (product) {
            // Track PDP view
            dataLayerAction({
                type: 'PDP',
                data: product
            })
            // Check if promotional tile was clicked
            if (isPromotionalProductTileClicked) {
                dataLayerAction({
                    type: 'PROMOTION_CLICK',
                    data: product
                })
            }
        }
    }, [product?.id])

    useEffect(() => {
        if (product) {
            const relatedProductsList = (product.related_products ?? []).filter(
                (relatedProduct: any) =>
                    relatedProduct.stock_status !== 'OUT_OF_STOCK'
            )
            // Track related products list
            if (relatedProductsList.length > 0) {
                dataLayerAction({
                    type: 'PDP_RELATED_PRODUCTS_VIEW',
                    data: product
                })
            }
        }
    }, [product?.id])

    useEffect(() => {
        // Track cross-sell products list
        if (upSellCrossSell?.crosssell_products?.length > 0) {
            dataLayerAction({
                type: 'PDP_CROSS_SELL_PRODUCTS_VIEW',
                data: upSellCrossSell
            })
        }
    }, [upSellCrossSell?.id, upSellCrossSell?.crosssell_products?.length])

    useEffect(() => {
        // Track up-sell products list
        if (upSellCrossSell?.upsell_products?.length > 0) {
            dataLayerAction({
                type: 'PDP_UP_SELL_PRODUCTS_VIEW',
                data: upSellCrossSell
            })
        }
    }, [upSellCrossSell?.id, upSellCrossSell?.upsell_products?.length])
}
